import HBLoading from "@/components/HBLoading";
import TopicCard from "@/components/TopicCard";
import { getDiscoveryExplores, getGrocery, getSearchHotWord } from "@/services";
import useReq from "@/utils/useReq";
import { DeleteFilled } from "@ant-design/icons";
import { drop, random, take } from "lodash";
import { If, Then } from "react-if";
import styles from "./index.module.less";

interface SuggestConf {
  nail: {
    cover: {
      name: string;
      uid: string;
      url: string;
    }[];
    description: string;
    name: string;
    url: string;
    is_hidden: boolean;
  }[];
  rest: {
    cover: {
      name: string;
      uid: string;
      url: string;
    }[];
    description: string;
    name: string;
    url: string;
    is_hidden: boolean;
  }[];
}

interface SearchSuggestProps {
  searchHis: string[];
  clearSearchHis: () => void;
  setDropdownVisible: (visible: boolean) => void;
  hideSuggest: boolean;
  /** 前置内容：比如快速切换搜索范围按钮 */
  preAddOn?: React.ReactNode;
  onSearch: (
    text: string,
    extra?: {
      query?: any;
      type?: string;
    }
  ) => void;
}

/**
 * 搜索下拉推荐内容：搜索历史、热门搜索、推荐内容
 */
export default function SearchSuggest({
  searchHis,
  clearSearchHis,
  setDropdownVisible,
  hideSuggest,
  preAddOn = null,
  onSearch,
}: SearchSuggestProps) {
  const { data, loading } = useReq(async () => {
    const [data, manualConf] = await Promise.all([
      getDiscoveryExplores(),
      getGrocery<SuggestConf>("hb-search-dropdown"),
    ]);

    // 首位固定位置 钉住
    const nail = (manualConf?.nail || []).filter((item) => !item.is_hidden);
    // 剩余配置位置
    const rest = (manualConf?.rest || []).filter((item) => !item.is_hidden);

    // 配置不存在了或者，配置成了隐藏
    if (nail?.length == 0) {
      return {
        first: data.explores[0],
        explores: take([...rest, ...drop(data.explores, 1)], 8),
      };
    }

    return {
      first: nail[random(0, nail.length - 1)],
      explores: take([...rest, ...data.explores], 8),
    };
  });

  // 搜索热词
  const { data: hotWord } = useReq(getSearchHotWord);

  if (!(searchHis && searchHis.length) && hideSuggest) {
    return null;
  }

  return (
    <div className={styles.dropdown} id="search_dropdown">
      {preAddOn}

      {preAddOn && <div className={styles.split} />}

      {/* 搜索历史 */}
      <If condition={searchHis && searchHis.length}>
        <Then>
          <div className={styles.title}>
            最近搜索
            <DeleteFilled className={styles.del} onClick={clearSearchHis} />
          </div>
          <div className={styles.history}>
            {searchHis.map((text, index) => (
              <div
                key={index}
                className={styles.item}
                onClick={() => {
                  onSearch(text, { type: "历史搜索词" });
                }}
                title={text}
                data-gd-click="button_click"
                data-button-name={text}
                data-content-source="历史搜索词"
              >
                {text}
              </div>
            ))}
          </div>
        </Then>
      </If>

      {hotWord?.length && (
        <div>
          <div className={styles.title}>花瓣热搜</div>
          <div className={styles.hotword}>
            {hotWord.map((item, index) => (
              <div
                key={index}
                className={styles.item}
                onClick={() => {
                  onSearch(item.word, { type: "搜索热词" });
                }}
                title={item.word}
                data-gd-click="button_click"
                data-gd-expose="button_expose"
                data-button-name={item.word}
                data-content-source="搜索热词"
              >
                {item.word}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 热门精选 */}
      <If condition={!hideSuggest}>
        <Then>
          <div className={styles.title}>热门精选</div>
          {loading && !data ? (
            <HBLoading size="40" />
          ) : (
            <div className={styles.topic}>
              <div className={styles.left} data-content-source="搜索下拉框">
                <TopicCard
                  className={styles.item}
                  topic={data?.first}
                  height={140}
                  onClick={() => {
                    setDropdownVisible(false);
                  }}
                />
              </div>
              {data && (
                <div className={styles.right} data-content-source="搜索下拉框">
                  {data.explores.map((el, index) => (
                    <TopicCard
                      className={styles.item}
                      key={index}
                      topic={el}
                      height={64}
                      onClick={() => {
                        setDropdownVisible(false);
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </Then>
      </If>
    </div>
  );
}
